/**
 * Build a filesystem-safe PDF base name from the ROI / calculator display name.
 * Falls back to roi_report when name is empty.
 */
export function buildReportFileBaseName(roiName, roiId) {
  const sanitized = String(roiName ?? "")
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, "")
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "");

  if (sanitized) {
    return sanitized;
  }

  const idPart = String(roiId ?? "").trim();
  return idPart ? "roi_report" : "roi_report";
}

export function buildReportDownloadFileName(roiName, roiId, reportUuid) {
  const base = buildReportFileBaseName(roiName, roiId);
  // Prefer per-download report UUID; fall back to roiId (legacy: eis_roi_report-{roiId}.pdf)
  const suffix = String(reportUuid ?? roiId ?? "")
    .trim()
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, "");

  if (!suffix) {
    return `${base}.pdf`;
  }

  return `${base}-${suffix}.pdf`;
}
